//@flow
import React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import { TooltipDivOverflow } from 'common/components/core/wrappers/Div';
import type { Element } from 'react';
import type { List } from 'immutable';
import type { SkillModelType } from 'common/models/flow/Skill';
import theme from 'common/entity/BulkEditContainer.scss';

type Props = {
    skillIds: List<*>,
    skills: List<*>,
    showTooltip: boolean,
    theme: { +[string]: string },
    labelSelector: (
        skillId: SkillModelType,
        skills: List<SkillModelType>
    ) => string
};

const SkillsList = ({
    skillIds,
    skills,
    theme,
    showTooltip,
    labelSelector
}: Props): Element<any> => {
    const displayText = skillIds
        .map(skillId => labelSelector(skillId, skills))
        .join(', ');
    return (
        <TooltipDivOverflow
            className={classnames(theme.cellText, {
                [theme.isEmpty]: !skillIds.size
            })}
            invert
            tooltip={showTooltip ? displayText : ''}
        >
            {displayText}
        </TooltipDivOverflow>
    );
};

SkillsList.defaultProps = {
    showName: true,
    showTooltip: true,
    labelSelector: (skillId, skills) => {
        if (!skills) {
            return skillId.id;
        }
        const skill = skills.find(
            skill =>
                skill.clientId === skillId.clientId && skill.id === skillId.id
        );
        return skill ? skill.name : skillId.id;
    }
};

export default themr('ThemedSkillsList', theme)(SkillsList);
